import React from 'react';
import PropTypes from 'prop-types';
import { QuickDrawer } from 'shared/components';
import Button from '@mui/material/Button';
import styled from 'styled-components';
import { ImpactReceiptMin } from 'shared/components/ImpactReceiptMin';

const QuickView = ({ open, onClose, investmentId }) => {
  const openFullIr = () => window.open(`/donor/impact-receipt/${investmentId}`);
  if (!open) return null;
  return (
    <QuickDrawer open={open} onClose={onClose}>
      <Container>
        <Scroller>
          <ImpactReceiptMin investmentId={investmentId} />
        </Scroller>
        <ButtonMain variant="contained" color="primary" onClick={openFullIr}>
          See Full Impact Receipt
        </ButtonMain>
      </Container>
    </QuickDrawer>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 67px);
`;

const Scroller = styled.div`
  overflow-y: scroll;
  height: calc(100% - 100px);
`;

const ButtonMain = styled(Button)`
  position: absolute !important;
  left: 20px;
  bottom: 20px !important;
  width: calc(100% - 40px);
  height: 48px;
  span {
    text-transform: none !important;
    font-weight: 700;
    font-size: 16px;
  }
`;

QuickView.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default QuickView;
